/**
 * @generated SignedSource<<123178200e490e6a2ba9dace05b7cbae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type readAccountBalanceFragment$data = {
  readonly assetOrFiatCurrency: {
    readonly assetBalanceBreakdown?: {
      readonly availableToSendBalance: {
        readonly currency: string;
        readonly value: string;
      } | null;
    } | null;
    readonly type?: string;
  } | null;
  readonly availableBalance: {
    readonly currency: string;
  };
  readonly " $fragmentType": "readAccountBalanceFragment";
};
export type readAccountBalanceFragment$key = {
  readonly " $data"?: readAccountBalanceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"readAccountBalanceFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "readAccountBalanceFragment"
};

(node as any).hash = "8f18c662090bc96f9aa7e36fcbe7f6b3";

export default node;
